import moment from 'moment-timezone'

export const utcToLocal = (utcDate) => moment.utc(utcDate).local()

export const utcToLocalDateAtTime = (utcDate) => {
  const localDate = utcToLocal(utcDate)
  return `${localDate.format('MMM DD, YYYY')} at ${localDate.format('hh:mm A')}`
}
